import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import sizes from '../../theme/sizes'

export const Container = styled.div`
  position: fixed;
  z-index: 9000;
  width: 100%;
  height: 100%;
  top: 0;
  border-radius: 2rem;

  .gdpr-settings {
    z-index: 9000;
    color: black;
    width: 100%;
    height: 100%;
  }

  .gdpr-overlay {
    background-color: rgba(0, 0, 0, 0.75);
    pointer-events: none;
    width: 100%;
    height: 100%;
  }

  .gdpr-popin {
    background-color: ${({ theme }) => theme.colors.pureWhite};
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transform: none;

    ${breakpoints.up('tablet')} {
      max-width: calc(100% - 4rem);
      height: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    ${breakpoints.up('desktop')} {
      max-width: calc(${sizes.desktop / 10}rem - 4rem);
    }
  }

  .gdpr-container {
    position: absolute;
    left: 2rem;
    right: 2rem;
    top: 2rem;
    bottom: 4rem;
    display: flex;
    flex-direction: column;
    ${breakpoints.up('tablet')} {
      left: 6rem;
      right: 6rem;
      top: 6rem;
      bottom: 6rem;
    }
  }

  .gdpr-content-wrapper {
    width: 100%;
    height: 100%;
    overflow: auto;
    flex: 1;
  }

  .gdpr-content {
    padding-right: 2rem;
  }

  .gdpr-title {
    ${({ theme }) => theme.textStyles.H2};
    color: ${({ theme }) => theme.colors.royalBlue};
    font-size: 2.2rem;
    line-height: 2.7rem;
    text-transform: uppercase;
    margin: 0 0 2rem 0;
  }

  .gdpr-description {
    ${({ theme }) => theme.textStyles.textMedium};
    color: ${({ theme }) => theme.colors.nightRider};
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin-bottom: 6rem;
  }

  .gdpr-section {
    border-bottom: solid 0.1rem grey;
    margin-bottom: 3rem;
    position: relative;
    padding-bottom: 2rem;
    ${breakpoints.up('tablet')} {
      padding-bottom: 0;
    }
  }

  .gdpr-section-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .gdpr-section-description {
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }

  .gdpr-toggle {
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 1.5rem;
    position: relative;
    justify-content: flex-end;
    ${breakpoints.up('tablet')} {
      margin-top: 0;
      position: absolute;
    }
  }

  .gdpr-toggle-track {
    width: 4.8rem;
    height: 2.3rem;
    background-color: grey;
    border-radius: 3.5rem;
    position: relative;
    transition: all 0.3s;
  }

  .gdpr-toggle-cursor {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.silver};
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    transition: all 0.3s;
  }

  .gdpr-toggle-status {
    font-size: 1.6rem;
    margin-right: 2rem;
    transition: all 0.3s;
    ${({ theme }) => theme.textStyles.textMedium};
    color: ${({ theme }) => theme.colors.silver};
  }

  .validated {
    .gdpr-toggle-track {
      background-color: ${({ theme }) => theme.colors.royalBlue};
    }
    .gdpr-toggle-cursor {
      background-color: ${({ theme }) => theme.colors.silver};
      left: 2.8rem;
    }
    .gdpr-toggle-status {
      color: ${({ theme }) => theme.colors.silver};
    }
  }

  .gdpr-footer {
    margin-top: 1.5rem;
    padding-right: 1.5rem;
    text-align: right;
  }

  .gdpr-button {
    display: inline-flex;
    //extend: transition(all 0.3s);
    padding: 1rem 2rem;
    border-radius: 2rem;
    ${({ theme }) => theme.textStyles.textMedium};
    color: ${({ theme }) => theme.colors.pureWhite};
    margin-left: 1rem;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.royalBlue};
    &:hover {
      background-color: ${({ theme }) => theme.colors.royalBlue};
    }
  }
`
